import { transferToNative } from "@src/lib/WebAppBridge";
import React from "react";
import styled from "styled-components";

const LandRegisterOpenButton = () => {
    const handleSearchAddress = () => {
        transferToNative(JSON.stringify({ type: "LandingRegister" }), "onMissgoAIClicked");
    };

    return (
        <BoxStyle onClick={handleSearchAddress}>
            <ButtonStyle>
                <span className="redBold">Live</span>
                <span className="bold">토지•임야대장</span>열람
            </ButtonStyle>
        </BoxStyle>
    );
};

export default LandRegisterOpenButton;

const BoxStyle = styled.div`
    width: 100%;
    display: flex;
    justify-content: right;
`;
const ButtonStyle = styled.div`
    display: flex;
    align-items: center;
    padding: 4px 8px;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    gap: 4px;
    border-radius: 4px;
    background: #2275ee;
    color: #ffffff;
    box-sizing: border-box;
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    position: relative;
    cursor: pointer;

    .bold {
        font-size: 16px;
        font-weight: bold;
    }

    .redBold {
        border-radius: 24px;
        display: inline-block;
        width: max-content;
        background-color: #ff0000;
        padding: 0px 4px;
        gap: 10px;
        color: #ffffff;
        text-align: center;
        font-size: 14px;
        font-weight: bold;
    }
`;

export const showLandRegisterOpenButton = (type: string) => {
    return ["토지", "대지권", "대지지분"].includes(type);
};

export const showBuildingRegisterOpenButton = (type: string) => {
    return ["건물", "집합건물"].includes(type);
};
